import fetch from '../etc/pqfetch.js'

export function requestDemo(email, firstName, lastName, phoneNumber, hubspotCookie, source) {
	const body = fetch.query({ email, firstName, lastName, phoneNumber, hubspotCookie, source })

	return fetch(`/misc/demo/request`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			Accept: 'application/json'
		},
		body
	}).then(res => res.json())
}

export function validateDemo(preauthToken, code, firstName, lastName) {
	const body = fetch.query({ preauthToken, code, firstName, lastName })

	return fetch(`/misc/demo/validate`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			Accept: 'application/json'
		},
		body
	}).then(res => res.json())
}

export function submitGiftAddressAPI(preauthToken, email, firstName, lastName, company, address1, city, state, zip, country) {
	const body = fetch.query({ preauthToken, email, firstName, lastName, company, address1, city, state, zip, country })

	return fetch(`/misc/demo/gift-address`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			Accept: 'application/json'
		},
		body
	}).then(res => res.json())
}
